import { useStaticQuery, graphql } from 'gatsby';


export const Illustration = () => {
	const { wpgraphql } = useStaticQuery(
		graphql`
			query illustrationPosts {
				wpgraphql {
					posts(first: 12, where: { categoryName: "illustration" }) {
						nodes {
							title
							colourFeatureImage
							link
							featuredImage {
								sourceUrl
								srcSet
								mediaDetails {
									width
									height
								}
							}
							avVideoTeaser {
								avVideoTeaser {
								mediaItemUrl
								}
							}    										
						}
					}
				}
			}
		`
	);

	return wpgraphql.posts.nodes;
};
